"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _player = require("@/api/player/player");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      queryGroup2: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      modelData: {
        queryValue: ""
      },
      modelDate2: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "300"
      }],
      defaultColumn2: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "200"
      }],
      funBtns: [{
        size: "small",
        click: "delMore",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      page2: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      total2: 0,
      listData: [],
      tableData2: [],
      options: [{
        name: "移出",
        class: "edit",
        option: "delMore",
        span: 3
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      name: "",
      checkBoxs: [],
      checkBoxs2: [],
      allotDia: false
    };
  },
  methods: {
    //
    optAllot: function optAllot() {
      this.allotDia = false;
    },
    // 获取未分配的选手教师
    getNoAllotList: function getNoAllotList() {
      var _this = this;
      (0, _player.noAllotPlayer)({
        groupId: this.$route.query.groupId,
        stageId: this.$route.query.stageId,
        name: this.name2,
        pageSize: this.page2.pageSize,
        pageNum: this.page2.pageNumber
      }).then(function (res) {
        console.log(res, "未分配");
        var data = res.data;
        _this.tableData2 = data.list;
        _this.total2 = data.total;
      });
    },
    // 参赛选手的筛选
    search2: function search2(e) {
      this.name2 = e.name;
      this.getNoAllotList();
    },
    // 确定分配
    isAllot: function isAllot() {
      var _this2 = this;
      (0, _player.insetPlayer)({
        groupId: this.$route.query.groupId,
        stageId: this.$route.query.stageId,
        ids: this.checkBoxs2
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.$message.success("操作成功。");
          _this2.getTeacherLsit();
          _this2.allotDia = false;
        }
      });
    },
    // 取消分配
    noAllot: function noAllot() {
      this.allotDia = false;
    },
    // 筛选
    search: function search(e) {
      this.name = e.name;
      this.getTeacherLsit();
    },
    // 获取已分配选手列表.
    getTeacherLsit: function getTeacherLsit() {
      var _this3 = this;
      (0, _player.isAllotPlayer)({
        groupId: this.$route.query.groupId,
        stageId: this.$route.query.stageId,
        name: this.name,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        console.log(res, "已分配");
        var data = res.data;
        _this3.listData = data.list;
        _this3.totalData = data.total;
      });
    },
    // 新增
    add: function add() {
      this.allotDia = true;
      this.getNoAllotList();
    },
    // 移出
    delMore: function delMore(row) {
      var _this4 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      (0, _player.deletePlayer)({
        idList: id
      }).then(function () {
        _this4.getTeacherLsit();
        _this4.$message.success("操作成功。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    handleSelectionChange2: function handleSelectionChange2(e) {
      var _this6 = this;
      this.checkBoxs2 = [];
      e.forEach(function (item) {
        _this6.checkBoxs2.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getTeacherLsit();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getTeacherLsit();
    },
    handleCurrentChange2: function handleCurrentChange2(e) {
      this.page2.pageNumber = e;
      this.getNoAllotList();
    },
    handleSizeChange2: function handleSizeChange2(e) {
      this.page2.pageSize = e;
      this.page2.pageNumber = 1;
      this.getNoAllotList();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getTeacherLsit();
  }
};